import { defineComponent as _defineComponent } from 'vue'
import { ref } from "../../../../adapter-vue";
import { outsideClick } from "@tencentcloud/universal-api";
import Icon from "../../../common/Icon.vue";
import BottomPopup from "../../../common/BottomPopup/index.vue";
import { isPC, isUniFrameWork } from "../../../../utils/env";
import TUIChatConfig from "../../config";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  iconFile: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
  needDialog: {
    type: Boolean,
    default: true,
  },
  iconWidth: {
    type: String,
    default: "20px",
  },
  iconHeight: {
    type: String,
    default: "20px",
  },
  // Whether to display the bottom popup dialog on mobile devices
  // Invalid on PC
  needBottomPopup: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onIconClick", "onDialogClose", "onDialogShow"],
  setup(__props, { expose, emit: emits }) {

const props = __props





const isDark = ref(TUIChatConfig.getTheme() === "dark");
const showDialog = ref(false);
const toolbarItemRef = ref();
const dialogRef = ref();

const toggleToolbarItem = () => {
  emits("onIconClick", dialogRef);
  if (isPC) {
    outsideClick.listen({
      domRefs: toolbarItemRef.value,
      handler: closeToolbarItem,
    });
  }
  if (!props.needDialog) {
    return;
  }
  toggleDialogDisplay(!showDialog.value);
};

const closeToolbarItem = () => {
  showDialog.value = false;
  emits("onDialogClose", dialogRef);
};

const toggleDialogDisplay = (showStatus: boolean) => {
  if (showDialog.value === showStatus) {
    return;
  }
  showDialog.value = showStatus;
  switch (showStatus) {
    case true:
      emits("onDialogShow", dialogRef);
      break;
    case false:
      emits("onDialogClose", dialogRef);
  }
};

const onPopupClose = () => {
  showDialog.value = false;
};

expose({
  toggleDialogDisplay,
});

return { __sfc: true,props, emits, isDark, showDialog, toolbarItemRef, dialogRef, toggleToolbarItem, closeToolbarItem, toggleDialogDisplay, onPopupClose, Icon, BottomPopup, isPC, isUniFrameWork }
}

})